import { Form, Table } from "react-bootstrap";
import ToolBar from "../../../Componant/ToolBar";
import UseToggle from "../../../../Hooks/UseToggle";
import { useState } from "react";
import AddDesignation from "./AddDesignation";
import UpdateDesignation from "./UpdateDesignation";
import Moment from "react-moment";
import { designationServices } from "../../../../APIServices/UserData/designationServices";
import { useEffect } from "react";
import Swal from "sweetalert2";

const DesignationManagementData = () => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [designationData, setDesignationData] = useState("");
  const [designationCount, setDesignationCount] = useState(0);
  const [designationIds, setDesignationIds] = useState([]);

  const toggleSingle = (id) => {
    setDesignationIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const toggleAll = () => {
    if (designationIds.length === designations.length) {
      setDesignationIds([]);
    } else {
      setDesignationIds(designations.map((c) => c.id));
    }
  };

  const isAllChecked =
    designations.length > 0 && designationIds.length === designations.length;
  const isChecked = (id) => designationIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(designationCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, designationCount);

  const getDesignationList = async () => {
    setLoader(true)
    let data = await designationServices.getDesignationList("all", search, pageNumber, itemsPerPage)
    setDesignations(data?.data || [])
    setDesignationCount(data?.count || 0)
    setLoader(false)
  }

  const updatedDesignation = async (designationId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this designation?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.designationId = designationId
        userData.status = status
        let data = await designationServices.updatedDesignation(userData)
        if (data?.statusCode === 200) {
          getDesignationList()
        }
      }
    });
  };

  const deleteDesignation = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this designation?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.designationIds = designationIds
        let data = await designationServices.deleteDesignation(userData)
        if (data?.statusCode === 200) {
          getDesignationList()
        }
      }
    });
  };

  useEffect(() => {
    let designationData = designations?.find(item => item.designationId === designationIds?.[0])
    setDesignationData(designationData || "")
  }, [designationIds]);

  useEffect(() => {
    getDesignationList()
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={designationIds}
        setCheckedIds={setDesignationIds}
        start={start}
        end={end}
        totalItems={designationCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteDesignation}
        addField
        editField
      />

      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 169px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Designation</div>
                  </div>
                </th>
                <th>Total Member</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {designations?.map((dept) => (
                <tr key={dept.designationId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(dept.designationId)}
                          onChange={() => toggleSingle(dept.designationId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{dept.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{dept.totalMember}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() => updatedDesignation(dept?.designationId, dept.status === "active" ? "inactive" : "active")}
                      checked={dept.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {dept?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {dept?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddDesignation
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Designation`}
        getDesignationList={getDesignationList}
      />
      <UpdateDesignation
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Designation`}
        designationData={designationData}
        setDesignationData={setDesignationData}
        setDesignationIds={setDesignationIds}
        getDesignationList={getDesignationList}
      />
    </>
  );
};

export default DesignationManagementData;
